/* Centralized geodata and verified travel information for the Nippon Vino atlas. */
window.NipponVinoWineAtlasRegionData = Object.freeze({
  "yamanashi": {
    "macroRegion": "central-honshu",
    "capital": {
      "name": "Kōfu",
      "longitude": 138.56833,
      "latitude": 35.66228,
      "labelDx": -18,
      "labelDy": 18
    },
    "referenceCity": {
      "name": "Tokio",
      "longitude": 139.69171,
      "latitude": 35.6895,
      "labelDx": 32,
      "labelDy": 38
    },
    "wineHub": {
      "name": "Kōfu",
      "longitude": 138.56833,
      "latitude": 35.66228,
      "labelDx": -18,
      "labelDy": 24,
      "proximityText": "Kōfu · westlich von Tokio"
    },
    "additionalPoints": [
      {
        "name": "Katsunuma",
        "longitude": 138.7242,
        "latitude": 35.6713,
        "kind": "wine",
        "importance": "secondary",
        "labelDx": 20,
        "labelDy": 18
      }
    ],
    "travel": {
      "from": "Shinjuku Station",
      "to": "Kōfu Station",
      "mode": "JR Limited Express Kaiji / Azusa",
      "duration": "ca. 1 Std. 30 Min.",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/en/spot/1315/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Shinjuku Station",
        "longitude": 139.70056,
        "latitude": 35.68944
      },
      "toCoordinates": {
        "name": "Kōfu Station",
        "longitude": 138.56902,
        "latitude": 35.66704
      }
    },
    "secondaryTravel": null
  },
  "nagano": {
    "macroRegion": "central-honshu",
    "capital": {
      "name": "Nagano",
      "longitude": 138.18111,
      "latitude": 36.64858,
      "labelDx": -16,
      "labelDy": -14
    },
    "referenceCity": {
      "name": "Tokio",
      "longitude": 139.69171,
      "latitude": 35.6895,
      "labelDx": 10,
      "labelDy": -10
    },
    "wineHub": {
      "name": "Nagano City",
      "longitude": 138.18111,
      "latitude": 36.64858,
      "labelDx": -18,
      "labelDy": -18,
      "proximityText": "Nagano City · nordwestlich von Tokio"
    },
    "additionalPoints": [
      {
        "name": "Matsumoto",
        "longitude": 137.97194,
        "latitude": 36.23806,
        "kind": "wine",
        "labelDx": -20,
        "labelDy": 20
      },
      {
        "name": "Shiojiri",
        "longitude": 137.95374,
        "latitude": 36.11499,
        "kind": "wine",
        "importance": "secondary",
        "labelDx": 20,
        "labelDy": -16
      }
    ],
    "travel": {
      "from": "Tokyo Station",
      "to": "Nagano Station",
      "mode": "Hokuriku Shinkansen",
      "duration": "ca. 1 Std. 20 Min.",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/en/destinations/hokuriku-shinetsu/nagano/nagano-and-around/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Tokyo Station",
        "longitude": 139.76712,
        "latitude": 35.68124
      },
      "toCoordinates": {
        "name": "Nagano Station",
        "longitude": 138.18831,
        "latitude": 36.64331
      }
    },
    "secondaryTravel": {
      "from": "Shinjuku Station",
      "to": "Matsumoto Station",
      "mode": "JR Limited Express Azusa",
      "duration": "ca. 2 Std. 40 Min. bis 3 Std.",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/en/destinations/hokuriku-shinetsu/nagano/the-nagano-alps/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Shinjuku Station",
        "longitude": 139.70056,
        "latitude": 35.68944
      },
      "toCoordinates": {
        "name": "Matsumoto Station",
        "longitude": 137.96448,
        "latitude": 36.2302
      }
    }
  },
  "hokkaido": {
    "macroRegion": "hokkaido",
    "capital": {
      "name": "Sapporo",
      "longitude": 141.3545,
      "latitude": 43.0618,
      "labelDx": 12,
      "labelDy": -12
    },
    "referenceCity": {
      "name": "Sapporo",
      "longitude": 141.3545,
      "latitude": 43.0618,
      "labelDx": 11,
      "labelDy": -11
    },
    "wineHub": {
      "name": "Yoichi",
      "longitude": 140.7835,
      "latitude": 43.1954,
      "labelDx": -10,
      "labelDy": -11,
      "proximityText": "Yoichi · westlich von Sapporo"
    },
    "additionalPoints": [],
    "travel": {
      "from": "Haneda Airport",
      "to": "New Chitose Airport",
      "mode": "Flug",
      "duration": "ca. 1 Std. 30 Min. Flugzeit",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/en/destinations/hokkaido/hokkaido/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Haneda Airport",
        "longitude": 139.77984,
        "latitude": 35.54939
      },
      "toCoordinates": {
        "name": "New Chitose Airport",
        "longitude": 141.68134,
        "latitude": 42.7752
      }
    },
    "secondaryTravel": {
      "from": "New Chitose Airport",
      "to": "Sapporo",
      "mode": "JR Rapid Airport",
      "duration": "ca. 33–43 Min.",
      "sourceLabel": "JR Hokkaido",
      "sourceUrl": "https://www.jrhokkaido.co.jp/airport/index.html",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "New Chitose Airport",
        "longitude": 141.68134,
        "latitude": 42.7752
      },
      "toCoordinates": {
        "name": "Sapporo Station",
        "longitude": 141.35076,
        "latitude": 43.06866
      }
    },
    "additionalTravel": [
      {
        "from": "Sapporo",
        "to": "Yoichi",
        "mode": "Regionalverbindung",
        "duration": "ca. 1 Std. 40 Min.",
        "sourceLabel": "Hokkaido Tourism Organization",
        "sourceUrl": "https://www.visit-hokkaido.jp/asset/access-en/hokkaido_access_map04.pdf",
        "verifiedAt": "11.08.2026",
        "fromCoordinates": {
          "name": "Sapporo Station",
          "longitude": 141.35076,
          "latitude": 43.06866
        },
        "toCoordinates": {
          "name": "Yoichi Station",
          "longitude": 140.7942,
          "latitude": 43.1866
        }
      },
      {
        "from": "Tokyo Station",
        "to": "Sapporo",
        "mode": "Shinkansen und Limited Express mit Umstieg in Shin-Hakodate-Hokuto",
        "duration": "ca. 8 Std. insgesamt",
        "sourceLabel": "JNTO",
        "sourceUrl": "https://www.japan.travel/en/destinations/hokkaido/hokkaido/",
        "verifiedAt": "11.08.2026",
        "fromCoordinates": {
          "name": "Tokyo Station",
          "longitude": 139.76712,
          "latitude": 35.68124
        },
        "toCoordinates": {
          "name": "Sapporo Station",
          "longitude": 141.35076,
          "latitude": 43.06866
        },
        "note": "Keine direkte Shinkansen-Verbindung bis Sapporo."
      }
    ]
  },
  "yamagata": {
    "macroRegion": "north-honshu",
    "capital": {
      "name": "Yamagata",
      "longitude": 140.36333,
      "latitude": 38.25544,
      "labelDx": 11,
      "labelDy": -12
    },
    "referenceCity": {
      "name": "Yamagata",
      "longitude": 140.36333,
      "latitude": 38.25544,
      "labelDx": 10,
      "labelDy": -10
    },
    "wineHub": {
      "name": "Yamagata",
      "longitude": 140.36333,
      "latitude": 38.25544,
      "proximityText": "Yamagata · Regionsstadt und Weinanker"
    },
    "additionalPoints": [
      {
        "name": "Kaminoyama",
        "longitude": 140.2678,
        "latitude": 38.1497,
        "kind": "wine",
        "importance": "secondary",
        "labelDx": -10,
        "labelDy": 15
      }
    ],
    "travel": {
      "from": "Tokyo Station",
      "to": "Yamagata Station",
      "mode": "Yamagata Shinkansen",
      "duration": "ca. 2 Std. 30 Min.",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/en/destinations/tohoku/yamagata/yamagata-and-around/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Tokyo Station",
        "longitude": 139.76712,
        "latitude": 35.68124
      },
      "toCoordinates": {
        "name": "Yamagata Station",
        "longitude": 140.32725,
        "latitude": 38.24807
      }
    },
    "secondaryTravel": null
  },
  "iwate": {
    "macroRegion": "north-honshu",
    "capital": {
      "name": "Morioka",
      "longitude": 141.15448,
      "latitude": 39.70362,
      "labelDx": 11,
      "labelDy": -12
    },
    "referenceCity": {
      "name": "Morioka",
      "longitude": 141.15448,
      "latitude": 39.70362,
      "labelDx": 10,
      "labelDy": -10
    },
    "wineHub": {
      "name": "Morioka",
      "longitude": 141.15448,
      "latitude": 39.70362,
      "proximityText": "Morioka · Tor zum Weinland Iwate"
    },
    "additionalPoints": [
      {
        "name": "Hanamaki",
        "longitude": 141.1167,
        "latitude": 39.3886,
        "kind": "wine",
        "importance": "secondary",
        "labelDx": -10,
        "labelDy": 16
      }
    ],
    "travel": {
      "from": "Tokyo Station",
      "to": "Morioka Station",
      "mode": "Tōhoku / Akita Shinkansen",
      "duration": "ca. 2 Std. 10 Min.",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/en/destinations/tohoku/iwate/morioka-and-around/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Tokyo Station",
        "longitude": 139.76712,
        "latitude": 35.68124
      },
      "toCoordinates": {
        "name": "Morioka Station",
        "longitude": 141.13602,
        "latitude": 39.70155
      }
    },
    "secondaryTravel": null
  },
  "ibaraki": {
    "macroRegion": "central-honshu",
    "capital": {
      "name": "Mito",
      "longitude": 140.46667,
      "latitude": 36.36667,
      "labelDx": 11,
      "labelDy": -12
    },
    "referenceCity": {
      "name": "Tokio",
      "longitude": 139.69171,
      "latitude": 35.6895,
      "labelDx": 10,
      "labelDy": -10
    },
    "wineHub": {
      "name": "Ushiku",
      "longitude": 140.1495,
      "latitude": 35.9794,
      "labelDx": 20,
      "labelDy": -16,
      "proximityText": "Ushiku · nordöstlich von Tokio"
    },
    "additionalPoints": [],
    "travel": {
      "from": "Tokyo / Ueno",
      "to": "Ushiku Station",
      "mode": "JR Jōban Line",
      "duration": "ca. 1 Std.",
      "sourceLabel": "JNTO / JR East",
      "sourceUrl": "https://www.japan.travel/en/spot/1451/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Ueno Station",
        "longitude": 139.77725,
        "latitude": 35.71377
      },
      "toCoordinates": {
        "name": "Ushiku Station",
        "longitude": 140.141,
        "latitude": 35.9794
      },
      "secondarySourceUrl": "https://timetables.jreast.co.jp/en/timetable/list0222.html"
    },
    "secondaryTravel": null
  },
  "niigata": {
    "macroRegion": "central-honshu",
    "capital": {
      "name": "Niigata",
      "longitude": 139.02322,
      "latitude": 37.91619,
      "labelDx": -14,
      "labelDy": -12
    },
    "referenceCity": {
      "name": "Tokio",
      "longitude": 139.69171,
      "latitude": 35.6895,
      "labelDx": 10,
      "labelDy": -10
    },
    "wineHub": {
      "name": "Niigata City",
      "longitude": 139.02322,
      "latitude": 37.91619,
      "labelDx": -10,
      "labelDy": -10,
      "proximityText": "Niigata City · an der Küste des Japanischen Meeres"
    },
    "additionalPoints": [],
    "travel": {
      "from": "Tokyo Station",
      "to": "Niigata Station",
      "mode": "Jōetsu Shinkansen",
      "duration": "ca. 2 Std.",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/en/destinations/hokuriku-shinetsu/niigata/niigata-city-and-around/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Tokyo Station",
        "longitude": 139.76712,
        "latitude": 35.68124
      },
      "toCoordinates": {
        "name": "Niigata Station",
        "longitude": 139.06194,
        "latitude": 37.91204
      }
    },
    "secondaryTravel": null
  },
  "osaka": {
    "macroRegion": "west-honshu",
    "capital": {
      "name": "Osaka",
      "longitude": 135.50225,
      "latitude": 34.69372,
      "labelDx": 13,
      "labelDy": -12
    },
    "referenceCity": {
      "name": "Osaka",
      "longitude": 135.50225,
      "latitude": 34.69372,
      "labelDx": 16,
      "labelDy": -16
    },
    "wineHub": {
      "name": "Kashiwara",
      "longitude": 135.6262,
      "latitude": 34.5792,
      "labelDx": 18,
      "labelDy": 20,
      "proximityText": "Kashiwara · südöstlich von Osaka"
    },
    "additionalPoints": [
      {
        "name": "Habikino",
        "longitude": 135.6062,
        "latitude": 34.5579,
        "kind": "wine",
        "importance": "secondary",
        "labelDx": -18,
        "labelDy": 24
      }
    ],
    "travel": {
      "from": "Tokyo Station",
      "to": "Shin-Osaka Station",
      "mode": "Tōkaidō-Sanyō Shinkansen",
      "duration": "ca. 2 Std. 30 Min.",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/en/destinations/kansai/osaka/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Tokyo Station",
        "longitude": 139.76712,
        "latitude": 35.68124
      },
      "toCoordinates": {
        "name": "Shin-Osaka Station",
        "longitude": 135.50006,
        "latitude": 34.73348
      }
    },
    "secondaryTravel": {
      "from": "Tennoji Station",
      "to": "Kashiwara Station",
      "mode": "JR Yamatoji Line",
      "duration": "ca. 20 Min.",
      "sourceLabel": "Stadt Kashiwara",
      "sourceUrl": "https://www.city.kashiwara.lg.jp/docs/2014062700202/index.html.r",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Tennoji Station",
        "longitude": 135.51376,
        "latitude": 34.64721
      },
      "toCoordinates": {
        "name": "Kashiwara Station",
        "longitude": 135.6231,
        "latitude": 34.5865
      }
    },
    "additionalTravel": [
      {
        "from": "Kashiwara Station",
        "to": "Katashimo Winery",
        "mode": "zu Fuß",
        "duration": "ca. 15 Min.",
        "sourceLabel": "Osaka Info",
        "sourceUrl": "https://osaka-info.jp/en/spot/katashimo-winery/",
        "verifiedAt": "11.08.2026",
        "fromCoordinates": {
          "name": "Kashiwara Station",
          "longitude": 135.6231,
          "latitude": 34.5865
        },
        "toCoordinates": {
          "name": "Katashimo Winery",
          "longitude": 135.6357,
          "latitude": 34.5799
        }
      }
    ]
  },
  "okayama": {
    "macroRegion": "west-honshu",
    "capital": {
      "name": "Okayama",
      "longitude": 133.9195,
      "latitude": 34.65515,
      "labelDx": 11,
      "labelDy": -12
    },
    "referenceCity": {
      "name": "Okayama",
      "longitude": 133.9195,
      "latitude": 34.65515,
      "labelDx": 10,
      "labelDy": -10
    },
    "wineHub": {
      "name": "Okayama",
      "longitude": 133.9195,
      "latitude": 34.65515,
      "proximityText": "Okayama · Regionsstadt und Weinanker"
    },
    "additionalPoints": [],
    "travel": {
      "from": "Tokyo Station",
      "to": "Okayama Station",
      "mode": "Tōkaidō-Sanyō Shinkansen",
      "duration": "ca. 3 Std.",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/en/japan-magazine/okayama-land-of-sunshine/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Tokyo Station",
        "longitude": 139.76712,
        "latitude": 35.68124
      },
      "toCoordinates": {
        "name": "Okayama Station",
        "longitude": 133.91773,
        "latitude": 34.66631
      }
    },
    "secondaryTravel": null
  },
  "shimane": {
    "macroRegion": "west-honshu",
    "capital": {
      "name": "Matsue",
      "longitude": 133.05052,
      "latitude": 35.47229,
      "labelDx": 11,
      "labelDy": -12
    },
    "referenceCity": {
      "name": "Matsue",
      "longitude": 133.05052,
      "latitude": 35.47229,
      "labelDx": 10,
      "labelDy": -10
    },
    "wineHub": {
      "name": "Izumo",
      "longitude": 132.7547,
      "latitude": 35.3669,
      "labelDx": -10,
      "labelDy": 16,
      "proximityText": "Izumo · westlich von Matsue"
    },
    "additionalPoints": [],
    "travel": {
      "from": "Haneda Airport",
      "to": "Izumo Airport",
      "mode": "Flug",
      "duration": "ca. 1 Std. 30 Min. Flugzeit",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/national-parks/zh-hant/parks/daisen-oki/how-to-get-there/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Haneda Airport",
        "longitude": 139.77984,
        "latitude": 35.54939
      },
      "toCoordinates": {
        "name": "Izumo Airport",
        "longitude": 132.88995,
        "latitude": 35.41366
      }
    },
    "secondaryTravel": {
      "from": "Izumo Airport",
      "to": "Izumoshi Station",
      "mode": "Airport-Bus",
      "duration": "ca. 30 Min.",
      "sourceLabel": "JNTO",
      "sourceUrl": "https://www.japan.travel/national-parks/zh-hant/parks/daisen-oki/how-to-get-there/",
      "verifiedAt": "11.08.2026",
      "fromCoordinates": {
        "name": "Izumo Airport",
        "longitude": 132.88995,
        "latitude": 35.41366
      },
      "toCoordinates": {
        "name": "Izumoshi Station",
        "longitude": 132.7553,
        "latitude": 35.3609
      }
    },
    "additionalTravel": [
      {
        "from": "Tokyo Station",
        "to": "Matsue / Izumo",
        "mode": "Shinkansen bis Okayama, dann Limited Express",
        "duration": "ca. 6 Std. insgesamt bis Matsue",
        "sourceLabel": "JNTO",
        "sourceUrl": "https://www.japan.travel/en/destinations/chugoku/shimane/matsue-and-around/",
        "verifiedAt": "11.08.2026",
        "fromCoordinates": {
          "name": "Tokyo Station",
          "longitude": 139.76712,
          "latitude": 35.68124
        },
        "toCoordinates": {
          "name": "Matsue Station",
          "longitude": 133.0637,
          "latitude": 35.4639
        },
        "note": "ca. 3 Std. 20 Min. bis Okayama plus ca. 2 Std. 40 Min. bis Matsue."
      }
    ]
  }
});
